import React from 'react';
import {
  Grid,
  Typography,
  Card,
  CardContent,
  CardActionArea,
} from '@mui/material';
import Palette from '@mui/icons-material/Palette';
import ListAlt from '@mui/icons-material/ListAlt';
import Settings from '@mui/icons-material/Settings';
import Add from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';

const AdminButton = ({ icon: Icon, text, url }: any) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (url) {
      navigate(url);
    }
  };

  return (
    <Card sx={{ width: 120, height: 120, m: 1 }}>
      <CardActionArea
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
        onClick={handleClick}
      >
        <Icon sx={{ fontSize: 40, mb: 1 }} />
        <CardContent sx={{ p: 1 }}>
          <Typography variant="body2" align="center">
            {text}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

const Admin = () => {
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      style={{ minHeight: '72vh' }}
    >
      <Grid component="div" size={{ xs: 12, sm: 10, md: 8, lg: 6 }}>
        <Typography variant="h4" gutterBottom align="center">
          Listing Management Admin
        </Typography>
        <Grid container justifyContent="center" spacing={2}>
          <Grid component="div">
            <AdminButton
              icon={Palette}
              text="Setup Theme"
              url="/admin/branding"
            />
          </Grid>
          <Grid component="div">
            <AdminButton
              icon={ListAlt}
              text="Setup Field Template"
              url="/admin/template"
            />
          </Grid>
          <Grid component="div">
            <AdminButton icon={Settings} text="General Settings" />
          </Grid>
          <Grid component="div">
            <AdminButton icon={Add} text="Add New Feature" />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Admin;
